import React, { createContext, useState } from 'react';
import { ROLE_USER } from '../utils/Constants';

export const Context = createContext();

export const ContextProvider = ({ children }) => {
    const [sideMenuCurrentActive, setSideMenuCurrentActive] = useState(0);
    const [settingsCurrentActive, setSettingsCurrentActive] = useState(0);
    const [refreshMap, setRefreshMap] = useState({});
    const [isAddDeviceVisible, setIsAddDeviceVisible] = useState(false);
    const [isAddUserVisible, setIsAddUserVisible] = useState(false);
    const [defaultAccessType, setDefaultAccessType] = useState(ROLE_USER);

    const triggerRefresh = (key) => {
        setRefreshMap((prev) => ({
            ...prev,
            [key]: !(prev[key] ?? false),
        }));
    };

    return (
        <Context.Provider
            value={{
                sideMenuCurrentActive,
                setSideMenuCurrentActive,
                settingsCurrentActive,
                setSettingsCurrentActive,
                refreshMap,
                triggerRefresh,
                isAddDeviceVisible,
                setIsAddDeviceVisible,
                isAddUserVisible,
                setIsAddUserVisible,
                defaultAccessType,
                setDefaultAccessType,
            }}
        >
            {children}
        </Context.Provider>
    );
};
